import Skeleton from "@mui/material/Skeleton";
var Skeleton_default = Skeleton;
export {
  Skeleton_default as default
};
